import React from 'react';
import Image from 'next/image';
import {
  RootDiv,
  ErrorContainer,
  IconContainer,
  TextTypography,
  LinkTypography,
  SmallTypography,
  LinkContainer,
  MainTextContainer,
} from './error.styles';
import { HomeNavBar } from '@screens/home/components/homeNavBar';
import { PHONE_NUMBER } from '@config/environment';
import { useEventTracking } from '@hooks/useEventTracking';
import { ScreenEventType } from '@validators/Events/Screen';

export const ErrorScreen = () => {
  const { track } = useEventTracking();
  track(ScreenEventType.ScreenGenericErrorView);

  return (
    <>
      <HomeNavBar isVisible={true} />
      <RootDiv>
        <ErrorContainer>
          <IconContainer>
            <Image
              src="/assets/images/errorIcon.webp"
              alt="error"
              layout="fill"
              objectFit="contain"
              priority
            />
          </IconContainer>
          <MainTextContainer>
            <TextTypography>
              Ha ocurrido un problema y estamos trabajando para solucionarlo
            </TextTypography>
          </MainTextContainer>

          <LinkContainer>
            <LinkTypography
              onClick={() => {
                window.open(
                  `https://api.whatsapp.com/send?phone=${
                    PHONE_NUMBER.CLEAN
                  }&text=${encodeURI(
                    `Hola! Tuve un problema con la pagina. Necesito ayuda con `,
                  )}`,
                  '_blank',
                );
              }}
            >
              Pincha aquí
            </LinkTypography>
            <SmallTypography>
              si quieres recibir ayuda de un asistente
            </SmallTypography>
          </LinkContainer>
        </ErrorContainer>
      </RootDiv>
    </>
  );
};
